import { STATUS_CODES } from "../constants/StatusCodes";
import { isErrorWithStatus } from "./isErrorWithStatus";

export function isForbiddenError(error: unknown): boolean {
  return isErrorWithStatus(error, STATUS_CODES.FORBIDDEN);
}
